import type { SvgIconComponent } from '@mui/icons-material';
import { colors } from '@ovComponents/0-tokens/ref/palette/palette';
import { Box } from '@ovComponents/1-primative/box/box';
import { Icon } from '@ovComponents/1-primative/icon/icon';
import type { TypographyPropsVariants } from '@ovComponents/1-primative/typography/typography';
import { Typography } from '@ovComponents/1-primative/typography/typography';

interface StatusTagProps extends TypographyPropsVariants {
  size?: 'small' | 'medium';
  label: string;
  color?:
    | 'primary'
    | 'negative'
    | 'warning'
    | 'positive'
    | 'neutral'
    | 'informative';
  icon: SvgIconComponent;
  weight?: 'regular' | 'bold';
  right?: boolean;
}

export const StatusTag = ({
  size = 'small',
  label,
  color = 'positive',
  icon,
  variant,
  weight,
  right,
}: StatusTagProps) => (
  <Box
    display='flex'
    flexDirection='row'
    alignItems='center'
    justifyContent={right ? 'right' : 'flex-start'}
  >
    <Icon
      icon={icon}
      size={size}
      sx={{
        color: color === 'neutral' ? colors.neutral600 : colors[color],
        mr: '4px',
      }}
    />
    <Typography
      variant={variant || (size === 'small' ? 'labelSmall' : 'labelLarge')}
      weight={weight}
      sx={{ whiteSpace: 'nowrap' }}
    >
      {label}
    </Typography>
  </Box>
);
